export enum TypePersistence {
  DATI_EVENTO_RICONOSCIMENTO_M = 'DATI_EVENTO_RICONOSCIMENTO_M',
  DATI_EVENTO_RICONOSCIMENTO_P = 'DATI_EVENTO_RICONOSCIMENTO_P',
  EVENTO_RICONOSCIMENTO_CONSENSO_M = 'EVENTO_RICONOSCIMENTO_CONSENSO_M',
}
